var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-section"},[_c('div',{staticClass:"list-accordion"},[_c('div',{staticClass:"container"},_vm._l((_vm.items),function(item,index){return _c('AccordionItem',{key:`accordion-item-${index}`,attrs:{"item":_vm.parse(item)},on:{"highlightField":_vm.highlightField}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }